import { provide, inject } from 'vue'
import { GTM_SOURCE_KEY } from '@/constants/injectionKey'
import { GtmSource } from '@/view-models/gtm'

/**
 * Provide a GtmSource value to all descendant components.
 * Call in setup() of page or container component.
 * Silently skips if source is nullish (no provide when source is not set).
 */
export function provideGtmSource(source: GtmSource | null | undefined) {
  if (source) {
    provide(GTM_SOURCE_KEY, source)
  }
}

/**
 * Inject the GtmSource from nearest ancestor.
 * Returns null if no ancestor provides a source (e.g. direct URL access).
 */
export function useGtmSourceInject(): GtmSource | null {
  return inject<GtmSource | null>(GTM_SOURCE_KEY, null)
}

/**
 * Push the given Source value to the GTM dataLayer.
 * Use before navigating to a product-related page so that
 * downstream events (Product Detail Viewed, etc.) carry the correct Source.
 */
export function pushGtmSource(source: GtmSource) {
  const { $gtm } = useNuxtApp()
  $gtm?.push({ Source: source })
}

/**
 * Clear the Source value from the GTM dataLayer.
 * Call after ORDER_CREATED has been sent to avoid stale Source on subsequent events.
 */
export function clearGtmSource() {
  const { $gtm } = useNuxtApp()
  $gtm?.push({ Source: null })
}
